module.exports = __webpack_public_path__ + "static/img/5.706d24a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/17/5.png
// module id = gju5
// module chunks = 2